// extracted by mini-css-extract-plugin
module.exports = {"page":"NotFound_page__3sqUP","notFound":"NotFound_notFound__1Nv79","notText":"NotFound_notText__3Tttv"};